<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref, computed} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	
	const emit = defineEmits(['nextStep', 'updateForm']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/database" }
	});
	const { errorMessage, isError, upgrade, progress, submitOnEnter,
			sendForm, nextStep, 
			errEmptyStringClass, errEmptyNumberClass  } = useBaseStep(props,emit,validateForm);
	
	function validateForm(): boolean {
		if (!Boolean(props.form.mySqlPath)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.mySqlDatabaseName)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.mySqlEncoding)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.mySqlUser)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.mySqlPassword)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		return true;
	}
	
	console.log("charset:"+props.form.mySqlEncoding);
	
	function onSubmit(): void {
		sendForm(props.form,'Folders');
	}	
</script>
<template>
	<div>
		<div class="formTitle">{{msg("install.title.database")}}</div>
		<form @submit.prevent>
		<table border="0" cellspacing="0" class="formTable">
			<tr>
				<th><b>{{msg("install.mysql.path")}}:</b></th>
				<td><input type="text" :value="form.mySqlPath" size="32" @keypress="submitOnEnter($event,onSubmit)"
						@input="$emit('updateForm', 'mySqlPath', $event.target.value)" :class="errEmptyStringClass(form.mySqlPath)"></td>
			</tr>
			<tr>
				<th><b>{{msg("install.mysql.port")}}:</b></th>
				<td><input type="text" :value.number="form.mySqlPort" size="7" 
						@input="$emit('updateForm', 'mySqlPort', $event.target.value)" :class="errEmptyNumberClass(form.mySqlPort)"></td>
			</tr>
			<tr>
				<th><b>{{msg("install.mysql.database")}}:</b></th>
				<td><input type="text" :value="form.mySqlDatabaseName" size="32" @keypress="submitOnEnter($event,onSubmit)"
						@input="$emit('updateForm', 'mySqlDatabaseName', $event.target.value)" :class="errEmptyStringClass(form.mySqlDatabaseName)"></td>
			</tr>
			<tr>
				<th><b>{{msg("install.mysql.encoding")}}:</b></th>
				<td>
					<select :value="form.mySqlEncoding" 
							@input="$emit('updateForm', 'mySqlEncoding', $event.target.value)"
							:class="errEmptyStringClass(form.mySqlEncoding)">
						<option value="UTF-8" >UTF-8</option>
						<!--option v-if="upgrade" value="Cp1250">Windows-1250</option-->
					</select>
			</td>
			</tr>
			<tr>
				<th><b>{{msg("install.mysql.user")}}:</b></th>
				<td><input type="text" :value="form.mySqlUser" size="32" @keypress="submitOnEnter($event,onSubmit)"
						@input="$emit('updateForm', 'mySqlUser', $event.target.value)" :class="errEmptyStringClass(form.mySqlUser)"></td>
			</tr>
			<tr>
				<th><b>{{msg("install.mysql.password")}}:</b></th>
				<td><input type="password" :value="form.mySqlPassword" size="32" @keypress="submitOnEnter($event,onSubmit)"
						@input="$emit('updateForm', 'mySqlPassword', $event.target.value)" :class="errEmptyStringClass(form.mySqlPassword)"></td>
			</tr>
			<tr>
				<td colspan="2"><error-msg :show="isError" :msg="errorMessage"/></td>
			</tr>
			<tr>
				<td style="padding-top:10px" colspan="2">
					<button @click="nextStep(upgrade?'Upgrade':'Selection')" class="sbutton">
						<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
					</button>
					&nbsp;
					<progress-button @click="onSubmit" :progress="progress"
						class="button" icon="page-next-16-full">
						{{msg('install.butt.next')}}
					</progress-button>
				</td>
			</tr>
		</table>
		</form>
	</div>
</template>
